import { defineStore } from 'pinia';
import { UserCenterState } from './types';
import { StoreModuleName } from '../../constants';
import { useUserStore } from '../user';
// 用户中心 公用状态
import {
  getUserCenterCategoryByCid,
  getAppUserCenterCategoryByCid,
} from '~/src/api/modules/common';
import {
  USER_CENTER_SUBJECT_STORAGE_KEY,
  USER_CENTER_APP_USER_SUBJECT_STORAGE_KEY,
} from '~/src/constants/exam/storage';
import { UserCenterCategory } from '~/src/api/modules/common/types';

export const useUserCenterStore = defineStore(StoreModuleName.USER_CENTER, () => {
  const userStore = useUserStore();
  const route = useRoute();

  const createInitState = (): UserCenterState => {
    return {
      // 用户中心专用科目，与首页科目可不一致
      subjectId: '', // 获取个人中心pc 端选中的科目id
      subjectCategory: [],
      appSubjectCategory: [],
    };
  };

  const state = ref(createInitState());

  // 更新 pc科目id
  const initSubjectId = async () => {
    if (state.value.subjectId) {
      return;
    }

    const routeSubjectId = (route.query.userSubject || '') as string;
    const localSubjectId =
      window.localStorage && localStorage.getItem(USER_CENTER_SUBJECT_STORAGE_KEY);

    if (routeSubjectId) {
      state.value.subjectId = routeSubjectId;
    } else if (localSubjectId) {
      state.value.subjectId = localSubjectId;
    } else {
      state.value.subjectId = userStore.userMeta.subjectId;
    }
  };

  const updateSubjectId = (id?: string) => {
    if (!id) {
      return;
    }

    state.value.subjectId = id;

    if (process.client && localStorage) {
      localStorage.setItem(USER_CENTER_SUBJECT_STORAGE_KEY, id);
    }
  };

  // 更新 app科目id
  const updateAppSubjectId = (id?: string) => {
    state.value.subjectId = id ?? '';

    if (process.client && localStorage) {
      localStorage.setItem(USER_CENTER_APP_USER_SUBJECT_STORAGE_KEY, id ?? '');
    }
  };

  // 重置
  const resetState = () => {
    state.value = createInitState();
  };

  // 获取个人中心的科目筛选（pc）
  const updatePcCategoryList = async () => {
    const res = await getUserCenterCategoryByCid().catch(err => {
      console.error('API Error getUserCenterCategoryByCid:', err);

      return {
        data: [] as UserCenterCategory[],
      };
    });

    return (state.value.subjectCategory = res.data);
  };

  // 获取个人中心的科目筛选（app）
  const updateAppCategoryList = async () => {
    const res = await getAppUserCenterCategoryByCid().catch(err => {
      console.error('API Error getUserCenterCategoryByCid:', err);

      return {
        data: [] as UserCenterCategory[],
      };
    });

    return (state.value.appSubjectCategory = res.data);
  };

  return {
    state,
    // staticState,
    initSubjectId,
    updateSubjectId,
    resetState,
    updatePcCategoryList,
    updateAppCategoryList,
  };
});
